import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import CoreServices from "./CoreServices";
import Faq from "./Faq";
import HeroBanner from "../HeroBanner";
import PartnerWithUs from "./PartnerWithUs";
import WhyChooseUs from "./WhyChooseUs";

const Home = () => {
  return (
    <>
      <Header />
      <Helmet>
        <title>
          Happy Pay Fintech - Empowering Retailers with Digital Financial
          Services
        </title>
        <meta
          name="description"
          content="Happy Pay Fintech offers a comprehensive platform for retailers and agents. Services include AEPS, DMT, CMS, PAN card, and utility bill payments. Join India's digital revolution."
        />
      </Helmet>

      <div className="body-overlay"></div>

      <main>
        {/* ===== Banner Area ===== */}
        <HeroBanner />
        <CoreServices />
        <PartnerWithUs />
        <WhyChooseUs />
        <Faq />
      </main>
      <Footer />
    </>
  );
};

export default Home;
